import React, { createRef } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const Home = () => {
  const newRef = createRef();
  const scrollTo = () => {
    newRef.current.scrollIntoView({ beahvior: "smooth" });
  };
  return (
    <div>
      <div className='home-banner'>
        <div className='home-title'>
          <h1>E-učilnica za učence OŠ Bičevje</h1>
          <h3>angleški jezik</h3>
        </div>
      </div>
      <div className='icons-container'>
        <h2 className='home-top-title'>ZAHTEVNA NAVODILA UPORABE STRANI</h2>
        <div className='icon-item'>
          <i className='fas fa-search'></i>
          <h1>1. KORAK</h1>
          <p>Preberi spodnja navodila.</p>
          <a href='#home-navodila-glavna'></a>
          <button onClick={() => scrollTo()}>Klikni me</button>
        </div>
        <div className='icon-item'>
          <i className='fas fa-user-graduate'></i>
          <h1>2. KORAK</h1>
          <p>Klikni na zavihek "Učne ure" ter izberi razred.</p>
        </div>
        <div className='icon-item'>
          <i className='fas fa-clipboard-check'></i>
          <h1>3. KORAK</h1>
          <p>Reši dane naloge.</p>
        </div>
      </div>
      <div className='home-navodila-container'>
        <div className='home-navodila-top'>
          <h1>
            Učitelji angleškega jezika vam sporočamo, da se za vsa dodatna
            vprašanja, obrnete na posameznega učitelja, ki poučeje določen
            razred.
          </h1>
          <p>klemen.kerstein@guest.arnes.si</p>
          <p>natasa.ursic@guest.arnes.si</p>
          <p>teacherelena.bicevje@gmail.com</p>
        </div>
      </div>
      <div className='home-navodila-glavna' ref={newRef}>
        <h1>navodila učnih ur ter vaj</h1>
        <h2>
          Naprošamo, da se učenci, kolikor je le mogoče, držijo danih napotkov,
          da ne bi prihajalo do nedoslednosti.
        </h2>
        <h3>1. Splošna navodila</h3>
        <p>- Otroci naj naloge opravljajo sproti.</p>
        <p>
          {" "}
          - Pri delu naj uporabljajo spletno stran in vse dane digitalne
          vsebine, učbenik, delovni zvezek, zvezek.
        </p>
        <p>
          {" "}
          - Opravljene vsebine naj bodo čitljive in urejene. Ob prihodu učencev
          v šolo bomo njihovo opravljeno delo, ki ni digitalne narave,
          pregledali.
        </p>
        <p>
          - Poleg vseh danih vaj, lahko učenci uporabljajo prostodostopne
          digitalne vsebine, ki so navedene pod zavihkom "DOSTOP" v navigacijski
          vrstici zgoraj.
        </p>
        <h3>2. Natančna navodila</h3>
        <p>
          - Vsako posredovano gradivo bo imelo zaporedno številko, naslov in
          datum.<br></br>
          <p>
            - Zaradi preglednosti, prosimo, da ob vsakem sklopu nalog, naslov in
            datum zapišejo v zvezek. <br></br>Pod naslovom in datumom naj bodo,
            če bo bo v učni uri tako navedeno, zapisane in rešene predvidene
            naloge.
          </p>
        </p>
        <p>
          - Ob reševanju bodo naleteli na neznane besede. Tako kot je praksa pri
          pouku,<br></br> morajo te nove besede izpisati v obliki slovarčka. V
          primeru, da otrok besede razume, kljub vsemu izpiše ključno besedišče.
        </p>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <div className='quotes-container'>
        <div className='quotes'>
          <h1>“I'm smart enough to know that I'm dumb.”</h1>
          <p>― Richard Feynman</p>
        </div>
        <div className='quotes'>
          <h1>
            {" "}
            “What you do speaks so loudly that I cannot hear what you say.”
          </h1>
          <p>– Ralph Waldo Emerson</p>
        </div>
        <div className='quotes'>
          <h1>
            {" "}
            “The surest sign that intelligent life exists elsewhere in the
            universe is that it has never tried to contact us.”
          </h1>
          <p>– Bill Watterson</p>
        </div>
      </div>
      <CookieConsent
        location='bottom'
        buttonText='Razumem'
        cookieName='myAwesomeCookieName2'
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "1.2rem" }}
        expires={150}
      >
        <span style={{ fontSize: "1.2rem" }}>
          Stran uporablja piškote za izboljšanje uporabe strani. Z nadaljno
          uporabo naše strani sprejemate uporabo piškotov.{" "}
        </span>
        <Link to='/cookies' style={{ color: "teal", fontSize: "1.2rem" }}>
          Več
        </Link>{" "}
      </CookieConsent>
    </div>
  );
};

export default Home;
